var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.7502L15.75 9.00023M15.75 9.00023L12 5.25023M15.75 9.00023H6.75M9 12.7502C9 12.9719 9 13.0828 8.99176 13.1788C8.90612 14.1767 8.17114 14.9979 7.18878 15.1932C7.09427 15.212 6.98401 15.2242 6.76376 15.2487L5.99771 15.3338C4.84686 15.4617 4.27141 15.5256 3.81425 15.3793C3.2047 15.1843 2.70706 14.7389 2.44588 14.1546C2.25 13.7164 2.25 13.1374 2.25 11.9795V6.021C2.25 4.86305 2.25 4.28408 2.44588 3.84587C2.70706 3.26159 3.2047 2.81618 3.81425 2.62112C4.27141 2.47483 4.84684 2.53877 5.99771 2.66664L6.76376 2.75176C6.98409 2.77624 7.09425 2.78848 7.18878 2.80727C8.17114 3.0026 8.90612 3.82376 8.99176 4.82169C9 4.91771 9 5.02855 9 5.25023",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.5c64dd29780ced6c267565990dc22fae.svg";
export { ForwardRef as ReactComponent };